<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>
        <div>
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <input v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                            </div>
                        </div>
                        <div class="col-md-4" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="col-md-4 float-right" />
                </div>
            </div>
            <b-card no-body class="col-md-12 p-1">
                <div class="row p-2">
                    <div class="col-md-12">
                        <div class="table-responsive-sm" style="overflow-x: auto">
                            <table class="table b-table table-fixed">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Provinsi</th>
                                        <th>ID BPS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="isLoading">
                                        <td colspan="3" class="text-center">
                                            <b-spinner label="Loading..." variant="primary" />
                                        </td>
                                    </tr>
                                    <template v-if="!isLoading">
                                        <tr v-for="(item, key) in result" :key="item.id">
                                            <td>{{ item.id }}</td>
                                            <td>{{ item.nama_provinsi }}</td>
                                            <td>{{ item.id_bps }}</td>
                                        </tr>
                                    </template>
                                    <tr v-if="!isLoading && result.length === 0">
                                        <td colspan="3" class="text-center">
                                            Data is empty.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {
        BCard,
        BSpinner,
    } from 'bootstrap-vue'
    import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
    import Vue from 'vue'
    import VuejsDialog from 'vuejs-dialog'

    import 'vuejs-dialog/dist/vuejs-dialog.min.css'

    Vue.use(VuejsDialog)

    export default {
        components: {
            BCard,
            BSpinner,
        },
        title() {
            return 'Master Data - Provinsi'
        },
        watch: {
            filter: {
                handler: _.debounce(function () {
                    this.getData()
                }, 300),
                deep: true,
            },
        },
        setup() {
            return {
                checkPermission,
                successNotification,
                errorNotification,
            }
        },
        computed: {
        },
        data() {
            return {
                result: [],
                isLoading: false,
                filter: {
                    search: '',
                },
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData() {
                this.isLoading = true

                this.$http.post('/regions/provinces', {
                    search: this.filter.search,
                }).then(response => {
                    this.result = response.data.data
                    this.isLoading = false
                }).catch(() => {
                    this.isLoading = false
                })
            },
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
